import * as React from 'react'
import { FC, CSSProperties } from 'react'

import './DashboardVisualization.less'
import { SummaryBoxes } from './SummaryBoxes'

import ReactEchart from 'echarts-for-react'
import ObjectMap from 'echarts-for-react'
import { setEChartsRef } from '../../shared/echartsRef'
import { MergeProps } from '../containers/Dashboard'

export interface DashboardVisualizationDataProps {
    onEvents: MergeProps['onEvents']
    showTitle: boolean
    showSubTitle: boolean
    dashboardSettings?: DashboardSettingsDto
    showModule: boolean
    controlId: number
    options: ObjectMap
    width: number
    donorAmount: number
    dollarAmount: number
}

export interface DashboardVisualizationStyleProps {
    subTitleStyle?: CSSProperties
    titleStyle?: CSSProperties

    campaignsStyle?: CSSProperties
    dollarsStyle?: CSSProperties
    contributionsStyle?: CSSProperties
}

export type DashboardVisualizationProps = DashboardVisualizationDataProps & DashboardVisualizationStyleProps

export const setStyle = (style: string) => (
    <style
        dangerouslySetInnerHTML={{
            __html: style,
        }}
    />
)

export const buildStyles = (style: any) => `{
        ${style.backgroundColor ? `background-color: ${style.backgroundColor};` : ''}
        ${style.color ? `color: ${style.color};` : ''}
        ${style.fontSize ? `font-size: ${style.fontSize};` : ''}
        ${style.fontStyle ? `font-style: ${style.fontStyle};` : ''}
        ${style.fontWeight ? `font-weight: ${style.fontWeight};` : ''}
    }`

export const RenderDashboardStyles: FC<DashboardVisualizationProps> = ({ ...props }) => {
    const { controlId } = props
    return (
        <>
            {props.titleStyle && setStyle(` .dashboard-id-${controlId} h2 ${buildStyles(props.titleStyle)} `)}
            {props.subTitleStyle && setStyle(`.dashboard-id-${controlId} h3 ${buildStyles(props.subTitleStyle)}`)}
            {props.campaignsStyle && setStyle(`.dashboard-id-${controlId} .dashboard-container .dashboard-summary-boxes .campaigns-summary-box ${buildStyles(props.campaignsStyle)}`)}
            {props.dollarsStyle && setStyle(`.dashboard-id-${controlId} .dashboard-container .dashboard-summary-boxes .dollars-summary-box ${buildStyles(props.dollarsStyle)}`)}
            {props.contributionsStyle && setStyle(`.dashboard-id-${controlId} .dashboard-container .dashboard-summary-boxes .contributions-summary-box ${buildStyles(props.contributionsStyle)}`)}

        </>)
}

export const DashboardVisualization: FC<DashboardVisualizationDataProps> = props => {
    if (!props.dashboardSettings) {
        return <div />
    }
    return (<div className="dashboard">
        <RenderDashboardStyles {...props} dashboardSettings={props.dashboardSettings} />
        <div className={`dashboard-id-${props.controlId}`}>
            <div className="dashboard-container">
                {
                    props.showTitle &&
                    <h2>{props.dashboardSettings.moduleTitle}</h2>
                }
                {
                    props.showSubTitle &&
                    <h3>{props.dashboardSettings.moduleSubTitle}</h3>
                }
                {props.showModule &&
                    <>
                        <div className="dashboard-visualization-container">
                            <div className="dashboard-visualization-chart">
                                <ReactEchart
                                    style={{ width: '100%', height: '100%', minHeight: '300px' }}
                                    ref={(e: any) => setEChartsRef(props.controlId, e)}
                                    option={props.options as any}
                                    onEvents={props.onEvents}
                                    notMerge={true}
                                />
                            </div>
                            <SummaryBoxes donorCount={props.donorAmount} amount={props.dollarAmount} campaignCount={props.dashboardSettings.selectedControlIds.length} />
                        </div>
                    </>
                }
            </div>
        </div>
    </div>)

}
DashboardVisualization.displayName = 'DashboardVisualization'
